import { TabGroup, theme } from '@ahmdigital/ui';
import styled from 'styled-components';

import ItemCard from './item-card';

const { media } = theme;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  justify-content: space-between;
  margin-top: 2rem;

  @media (min-width: ${media.md}) {
    flex-direction: row;
  }
`;

export const StyledItemCard = styled(ItemCard)`
  @media (min-width: ${media.md}) {
    order: ${({ isBestSeller, index }) => (isBestSeller ? 2 : `${index}`)};
  }
`;

export const StyledTabGroup = styled(TabGroup)`
  [role='tablist'] {
    max-width: 35rem;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;
